import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, Loader2, CreditCard } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SubscriptionGate = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkSubscription();
  }, []);

  const checkSubscription = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await axios.get(`${API_URL}/api/user/subscription-check`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setHasAccess(response.data.has_access);
      setIsAdmin(response.data.is_admin);

      if (!response.data.has_access) {
        // User doesn't have subscription, redirect to payment
        setChecking(false);
      } else {
        setChecking(false);
      }
    } catch (err) {
      console.error('Error checking subscription:', err);
      setChecking(false);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-blue-600 mx-auto mb-4" />
          <p className="text-slate-600">Verifying subscription...</p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <Card className="w-full max-w-md shadow-xl">
          <CardHeader className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-blue-600" />
            </div>
            <CardTitle className="text-2xl">Subscription Required</CardTitle>
            <CardDescription>
              Subscribe to access all OSHA Safety Audit features
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="bg-slate-50 rounded-lg p-4">
              <h3 className="font-semibold text-slate-900 mb-2">What you'll get:</h3>
              <ul className="space-y-2 text-sm text-slate-700">
                <li>✓ Complete OSHA audit platform access</li>
                <li>✓ AI-powered safety analysis</li>
                <li>✓ Real-time monitoring & alerts</li>
                <li>✓ Compliance reporting & documentation</li>
                <li>✓ Knowledge center & training content</li>
              </ul>
            </div>

            <Button
              onClick={() => navigate('/subscription')}
              className="w-full bg-blue-600 hover:bg-blue-700"
            >
              <CreditCard className="w-4 h-4 mr-2" />
              View Subscription Plans
            </Button>

            <Button
              onClick={() => {
                localStorage.removeItem('auth_token');
                navigate('/login');
              }}
              variant="outline"
              className="w-full"
            >
              Logout
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};

export default SubscriptionGate;
